import "./Segmented.css"

/* One control, several panes. The compact layouts need it twice: the right dock stacks the round
   report and the chat where a desktop shows both at once, and the phone's Forces sheet holds what
   is two docks on a desktop.

   It owns nothing and renders what it is handed — no game concept, no counts of its own — so a
   caller can switch anything with it. */

const Segmented = ({ options, value, onChange, ariaLabel }) => (
  <div className="segmented" role="tablist" aria-label={ariaLabel}>
    {options.map((option) => {
      const selected = option.id === value
      return (
        <button
          key={option.id}
          type="button"
          role="tab"
          aria-selected={selected}
          className={`segmented-button ${selected ? "selected" : ""}`}
          onClick={() => onChange(option.id)}
        >
          <span className="segmented-label">{option.label}</span>
          {option.count != null && (
            <span className={`segmented-count ${option.badge ? "badge" : ""}`}>{option.count}</span>
          )}
        </button>
      )
    })}
  </div>
)

export default Segmented
